
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4326","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('path',{attrs:{"data-name":"Path 2347","d":"M11.684 3.349l-7.7 8.147a2.859 2.859 0 00-.625 1.343l-.347 3.038a1.432 1.432 0 001.753 1.659l3.019-.516a2.692 2.692 0 001.3-.7l7.7-8.147c1.331-1.406 1.931-3.009-.141-4.969-2.062-1.946-3.627-1.265-4.959.145z"}}),_c('path',{attrs:{"data-name":"Path 2348","d":"M10.4 4.708a5.743 5.743 0 005.11 4.828"}})])])
          )
        }
      }
    